import { Editor } from '@monaco-editor/react';
import { Action } from '@asurion-core/mx-asurion-ui-react';
import styled from 'styled-components';

const ActionButtonContainer = styled.div`
  margin-top: 0.5rem;
`;

export type JsonPreviewProps = {
  value: string;
  height?: string;
  copyLabel?: string;
  stripOuterBracesOnCopy?: boolean;
};

const stripOuterBraces = (value: string): string =>
  value
    .replace(/^\{\n/, '')
    .replace(/\n\}\s*$/, '')
    .replace(/^ {2}/gm, '');

export const JsonPreview = ({
  value,
  height = '400px',
  copyLabel = 'Copy Config',
  stripOuterBracesOnCopy = false,
}: JsonPreviewProps) => {
  const handleCopy = async (): Promise<void> => {
    try {
      const clipboardValue = stripOuterBracesOnCopy ? stripOuterBraces(value) : value;
      await navigator.clipboard.writeText(clipboardValue);
    } catch (error: unknown) {
      console.error('Failed to copy JSON to clipboard', error);
    }
  };

  return (
    <>
      <Editor
        defaultLanguage="json"
        height={height}
        value={value || '{}'}
        options={{
          readOnly: true,
          minimap: { enabled: false },
          wordWrap: 'on',
          wrappingIndent: 'same',
          formatOnPaste: true,
          formatOnType: false,
        }}
      />
      <ActionButtonContainer>
        <Action onClick={handleCopy}>{copyLabel}</Action>
      </ActionButtonContainer>
    </>
  );
};
